import { DRAG_PREVIEW_HEIGHT_PX, DRAG_PREVIEW_WIDTH_PX, SCROLL_DURING_DRAG_AMOUNT } from 'InpageEditorUI/lib/layoutSection/constants';
export const getWindowScrollBounds = () => {
  return {
    scrollTop: window.pageYOffset,
    scrollLeft: window.pageXOffset
  };
};
const SCROLL_LEFT_OR_RIGHT_BUFFER = 5;
export const pixelsToShiftScrollOnDrag = (mouseCoordinates, viewportWidth, viewportHeight, currentScrollLeft, currentScrollTop) => {
  const dragItemPositions = {
    top: mouseCoordinates.y,
    bottom: mouseCoordinates.y + DRAG_PREVIEW_HEIGHT_PX,
    left: mouseCoordinates.x,
    right: mouseCoordinates.x + DRAG_PREVIEW_WIDTH_PX / 2 + SCROLL_LEFT_OR_RIGHT_BUFFER
  };
  let topScrollAdjustment = 0;
  let leftScrollAdjustment = 0;
  if (currentScrollTop > 0 && dragItemPositions.top <= currentScrollTop + DRAG_PREVIEW_HEIGHT_PX) {
    topScrollAdjustment = -SCROLL_DURING_DRAG_AMOUNT;
  } else if (dragItemPositions.bottom >= currentScrollTop + viewportHeight) {
    topScrollAdjustment = SCROLL_DURING_DRAG_AMOUNT;
  }
  if (currentScrollLeft > 0 && dragItemPositions.left <= currentScrollLeft + DRAG_PREVIEW_HEIGHT_PX / 2 + SCROLL_LEFT_OR_RIGHT_BUFFER) {
    leftScrollAdjustment = -SCROLL_DURING_DRAG_AMOUNT;
  } else if (dragItemPositions.right >= currentScrollLeft + viewportWidth) {
    leftScrollAdjustment = SCROLL_DURING_DRAG_AMOUNT;
  }
  return [topScrollAdjustment, leftScrollAdjustment];
};